import * as ng from 'angular';
import * as _ from 'underscore';

import {Dataset} from '..';
import {LineChart} from './line-chart.service';

ng.module('e360').factory('lineChartCustomFactory', lineChartCustomFactory);

lineChartCustomFactory.$inject = ['instanceServiceFactory'];
function lineChartCustomFactory(instanceServiceFactory) {
   return instanceServiceFactory(LineChartCustom);
}

export class LineChartCustom extends LineChart {
   static $inject = ['ds'];
   protected constructor(protected ds: Dataset) {
      super(ds);
   }

   setData(data: any[]) {
      while (this.chart.series.length > 0) {
         this.chart.series.pop().remove();
      }
      if (data.length === 0) return;

      let xAxis = this.ds.xAxis;
      let yAxis = this.ds.yAxis;
      let maxRange = 0;
      _.each(data, (rowData, item) => {
         if (rowData.totalReg > maxRange) maxRange = rowData.totalReg;
      });
      if (this.ds.groupBy) {
         let grouped = _.groupBy(data, this.ds.groupBy.name);

         _.each(grouped, (val, key) => {
            this.chart.addSeries(
               {
                  name: key,
                  data: _.map(val, (d) => {
                     return _.extend(d, {
                        name: LineChart.formatValue(xAxis, d[xAxis.name]),
                        x: LineChart.nativeValue(xAxis, d[xAxis.name]),
                        y: d[yAxis.name]
                     });
                  })
               },
               false
            ); // false to disable default redraw
         });

         this.chart.redraw();
      } else {
         this.chart.update({
            xAxis: {
               categories: _.map(data, (d) => LineChart.formatValue(xAxis, d[xAxis.name])),
               title: {text: xAxis.label}
            },
            yAxis: {
               title: {text: yAxis.label}
            }
         });

         this.chart.addSeries({
            name: yAxis.label,
            data: _.map(data, (d) => d[yAxis.name])
         });

         // generate some random data for demo purposes
         let dataClone = _.clone(data);
         _.forEach(dataClone, function (row) {
            let addOrSubtract = Math.random() > 0.5 ? true : false;
            let random = Math.floor(Math.random() * maxRange);
            row.totalReg = addOrSubtract
               ? row.totalReg + random
               : row.totalReg - random > 0
               ? row.totalReg - random
               : random - row.totalReg;
         });
         this.chart.addSeries({
            name: yAxis.label + ' custom 1',
            data: _.map(dataClone, (d) => d[yAxis.name])
         });
         dataClone = _.clone(data);
         _.forEach(dataClone, function (row) {
            let addOrSubtract = Math.random() > 0.5 ? true : false;
            let random = Math.floor(Math.random() * maxRange);
            row.totalReg = addOrSubtract
               ? row.totalReg + random
               : row.totalReg - random > 0
               ? row.totalReg - random
               : random - row.totalReg;
         });
         this.chart.addSeries({
            name: yAxis.label + ' custom 2',
            data: _.map(dataClone, (d) => d[yAxis.name])
         });
         dataClone = _.clone(data);
         _.forEach(dataClone, function (row) {
            let addOrSubtract = Math.random() > 0.5 ? true : false;
            let random = Math.floor(Math.random() * maxRange);
            row.totalReg = addOrSubtract
               ? row.totalReg + random
               : row.totalReg - random > 0
               ? row.totalReg - random
               : random - row.totalReg;
         });
         this.chart.addSeries({
            name: yAxis.label + ' custom 3',
            data: _.map(dataClone, (d) => d[yAxis.name])
         });
      }
   }
}
export interface LineChartCustomFactory {
   ({ds: Dataset}): LineChartCustom;
}
